import { useCrud } from '@next-qr/lib-ui/hooks';
import type { CrudListOptions, CrudGetOptions } from '@next-qr/lib-ui/hooks/useCrud';
import { conversationApi } from './api';

export interface Conversation {
  id: number;
  name: string | null;
  type: string;
  created_by: string;
}

const crud = useCrud<Conversation>(conversationApi);

export const useConversationList   = (options?: CrudListOptions) => crud.useList({ ...options, subscriptionFn: conversationApi.subscribe });
export const useConversation       = (id: string | number, options?: CrudGetOptions) => crud.useGet(id, { ...options, subscriptionFn: conversationApi.subscribe });
export const useCreateConversation = (options?: Parameters<typeof crud.useCreate>[0]) => crud.useCreate(options);
export const useUpdateConversation = (options?: Parameters<typeof crud.useUpdate>[0]) => crud.useUpdate(options);
export const useRemoveConversation = (options?: Parameters<typeof crud.useRemove>[0]) => crud.useRemove(options);
